import { useState } from "react";

// Temporary Quick Check course comparison: per browser tab, independent of the shortlist.
export const COMPARE_MAX = 4;
const KEY = "wua:qc-compare";

export const compareKey = (r) => r?.degree_id || null;

export function toggleCompare(list, row, max = COMPARE_MAX) {
  const k = compareKey(row);
  if (!k) return { list, error: "no_course" };
  if (list.some((x) => compareKey(x) === k)) return { list: list.filter((x) => compareKey(x) !== k) };
  if (list.length >= max) return { list, error: "max" };
  return { list: [...list, row] };
}

function read(scope) {
  try {
    const s = JSON.parse(sessionStorage.getItem(KEY));
    return scope && s?.scope === scope && Array.isArray(s.rows) ? s.rows : [];
  } catch { return []; }
}
function write(scope, rows) {
  try {
    if (rows.length) sessionStorage.setItem(KEY, JSON.stringify({ scope, rows }));
    else sessionStorage.removeItem(KEY);
  } catch { /* storage unavailable: selection just lives in memory */ }
}

// `scope` identifies the inputs the rows were computed from (subjects, grades…).
// When it changes after a selection was made, the selection is cleared so old
// chances/costs are never compared; while the page is still hydrating, a stored
// selection for the same scope is restored.
export function useCompareSelection(scope) {
  const [rows, setRowsState] = useState(() => read(scope));
  const [prevScope, setPrevScope] = useState(scope);
  if (scope !== prevScope) {
    setPrevScope(scope);
    if (rows.length && prevScope) { write(scope, []); setRowsState([]); }
    else setRowsState(read(scope));
  }
  const setRows = (next) => { write(scope, next); setRowsState(next); };
  return [rows, setRows];
}
